import {
  ResourceBackgroundColor,
  ResourceImage,
} from "../../../models/LibraryModels";
import { ImageMap, importAll } from "../template";

declare const require: any;

const images: ImageMap = importAll(
  require.context("../resources", false, /\.(png|jpe?g|svg)$/)
);

export default images;

export const getImage = (value?: string) =>
  value && value.split("/").splice(1)[0].split(".").splice(0)[0];

const getValueByKey = (key: keyof typeof ResourceImage) => {
  return ResourceImage[key];
};
export const getColorbyKey = (key: keyof typeof ResourceBackgroundColor) => {
  return ResourceBackgroundColor[key];
};

export const getResourcesImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(images).find(
    ([item, value], index) =>
      getImage(item) ===
      getValueByKey(valueTemplateImage as keyof typeof ResourceImage)
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
